import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, nextTick } from '../../../../../adapter-vue';
import {
  IMessageModel,
  TUITranslateService,
} from '@tencentcloud/chat-uikit-engine';
import { getBoundingClientRectSync } from '@tencentcloud/universal-api';
import { TranslationTextType, translator } from '../../../utils/translation';

interface IProps {
  message: IMessageModel;
  translationContentVisible: boolean;
  isSingleTranslation: boolean;
  translationWrapperRef: HTMLDivElement | undefined;
}

interface IEmits {
  (e: 'toggleErrorStatus', status: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'translation-content',
  props: {
    message: { default: () => ({} as IMessageModel) },
    translationContentVisible: { type: Boolean },
    isSingleTranslation: { type: Boolean },
    translationWrapperRef: null
  },
  emits: ["toggleErrorStatus"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'toggleErrorStatus', status: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { message: IMessageModel, translationContentVisible: boolean, isSingleTranslation: boolean, translationWrapperRef: HTMLDivElement | undefined }




const translationFinished = ref<boolean>(false);
const translationErrorText = ref<string>('');
const translationTextList = ref<TranslationTextType[]>([]);
const calculateHeight = ref<number>(0);
const calculateWidth = ref<number>(0);

const translationLoadingRef = ref<HTMLDivElement>();
const translationContentRef = ref<HTMLDivElement>();

watch(() => props.translationContentVisible, (newVal: boolean) => {
  if (newVal) {
    translator.get(props.message)
      .then((result) => {
        translationFinished.value = true;
        translationTextList.value = result;

        nextTick(() => {
          const { height: originHeight, width: originWidth } = getBoundingClientRectSync(translationLoadingRef.value!);
          const { height, width } = getBoundingClientRectSync(translationContentRef.value!);
          calculateHeight.value = originHeight;
          calculateWidth.value = originWidth;
          requestAnimationFrame(() => {
            calculateHeight.value = height;
            calculateWidth.value = width;
            if (props.isSingleTranslation) {
              nextTick(() => {
                const { bottom } = getBoundingClientRectSync(props.translationWrapperRef);
                const { bottom: bottomWindow } = getBoundingClientRectSync('#messageScrollList');
                if (bottom > bottomWindow) {
                  const timer = setTimeout(() => {
                    props.translationWrapperRef!.scrollIntoView({ block: 'end', behavior: 'smooth' });
                    clearTimeout(timer);
                  }, 150);
                }
              });
            }
          });
        });
      })
      .catch((err) => {
        translationFinished.value = true;
        const { height: originHeight } = getBoundingClientRectSync(translationLoadingRef.value!);
        calculateHeight.value = originHeight;
        translationTextList.value = [];
        emits('toggleErrorStatus', true);
        translationErrorText.value = err.message;
      });
  }
}, { immediate: true });

return { __sfc: true,emits, props, translationFinished, translationErrorText, translationTextList, calculateHeight, calculateWidth, translationLoadingRef, translationContentRef, TUITranslateService }
}

})